const styles = (theme) => ({
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
  name:{marginTop: "10px"},
  colorBlock: {
    float: "left",
    display: "block",
    position: "relative",
    width: "30px",
    height: "30px",
  },

  orange: {
    backgroundColor: "#ecb76a",
    "&:hover": {
      background: "#ffd599",
    },
  },

  items: {
    textAlign: "center",
    border: "1px solid #ddd",
    margin: "0 0 15px",
    padding: "15px 15px 20px",
    borderRadius: "10px"
  },
  green: {
    backgroundColor: "#4caf50",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#4caf50b8",
    },
  },
  blue: {
    backgroundColor: "#a6d5fa",
    "&:hover": {
      backgroundColor: "#45a5f1",
    },
  },
  red: {
    backgroundColor: "#f53729",
    "&:hover": {
      backgroundColor: "#fab3ae",
    },
  },
});

export default styles;
